export default "__VITE_ASSET__EMbLODvy__"